import type {
  IColorSDK,
  IColorWithStatesSDK,
} from './colorPropsSDKFactoryBuilder';
import { buildColorPropsSDKFactoryCreator } from './colorPropsSDKFactoryBuilder';

export type IIconColorSDK = IColorSDK<'iconColor'>;

export type IIconColorWithStatesSDK = IColorWithStatesSDK<'iconColor'>;

export const createIconColorPropsSDKFactory =
  buildColorPropsSDKFactoryCreator('iconColor');
